import React from 'react'
import PropTypes from 'prop-types'

import styles from './loader.css'

const InputLoader = (props) => {
  const { customClass, dataQsId } = props

  return (
    <div className={`${styles.container} ${customClass}`} data-qs-id={dataQsId}>
      <div className={styles.spinner} />
    </div>
  )
}

InputLoader.propTypes = {
  customClass: PropTypes.string,
  dataQsId: PropTypes.string.isRequired,
}

export default InputLoader
